import { AuthProvider } from '@sdk/authentication/AuthContext';
import noop from '@sdk/utils/noop';

import { PremiumGuardProvider } from '@web/premiumGuard/PremiumGuardContext';

import ExportButton from './ExportButton';

const ExportButtonWithContext = (props) => {
  return (
    <AuthProvider currentUser={props.Authentication.user}>
      <PremiumGuardProvider
        openPremiumGuardModal={noop}
        openPricingModal={noop}
        openLaborCostVideoModal={noop}>
        <ExportButton {...props} />
      </PremiumGuardProvider>
    </AuthProvider>
  );
};

export default ExportButtonWithContext;
